import naturalCompare from 'natural-compare-lite';
import DecodeEntities from './DecodeEntities';

String.naturalCompare = naturalCompare;
String.decodeEntities = DecodeEntities;
